import * as types from "../../../actions/systemlevel/index";

export default function(state = null, action) {
  switch (action.type) {
    case types.SYSTEM_THIRD_PARTY_PAYEE_TOASTER_MESSAGE:
      return action.payload;
    default:
      return state;
  }
}
